import type { CampaignPickerProps } from "../types";

import { useIsMobile } from "../../hooks/useIsMobile";
import { CampaignPickerDesktop } from "../CampaignPickerDesktop";
import { CampaignPickerMobile } from "../CampaignPickerMobile";

export const CampaignPicker = (props: CampaignPickerProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <CampaignPickerMobile {...props} />;
  }

  return <CampaignPickerDesktop {...props} />;
};
